module.exports = __webpack_public_path__ + "static/media/refresh.a5cd38c8.jpg";